import React, { useState } from "react";
import { api } from "./api";
import { Time } from "./time";

// Dashboard card: today's model calls / errors, plus a "Test model" button that sends one tiny
// benign sample and shows label, latency and cost, or the exact error.
export default function LlmStatus({ data, styles, onTested }) {
  const [testing, setTesting] = useState(false);
  const [res, setRes] = useState(null);
  const test = async () => {
    setTesting(true); setRes(null);
    try { setRes((await api.llmTest()).data); }
    catch (ex) { setRes({ ok: false, provider: "?", model: "?", error_type: "RequestFailed", error: ex.message, latency_ms: 0 }); }
    finally { setTesting(false); if (onTested) onTested(); }
  };
  const e = data.llm_last_error;
  return (
    <div style={{ ...styles.card, fontSize: 12 }} data-testid="llm-status">
      Model calls today: <strong>{data.llm_calls_today ?? 0}</strong> · errors today:{" "}
      <strong style={{ color: (data.llm_errors_today || 0) > 0 ? "var(--hs-danger)" : undefined }}>{data.llm_errors_today ?? 0}</strong>
      {e && <> · last error <code>{e.type}</code>{e.status ? ` (HTTP ${e.status})` : ""}{e.reason ? ` — ${e.reason}` : ""} at <Time value={e.at} /></>}
      {data.llm_cap_resets_at && (
        <div data-testid="llm-cap-reset">
          Daily model cap{data.llm_daily_cap_aud ? ` (A$${data.llm_daily_cap_aud})` : ""} resets <Time value={data.llm_cap_resets_at} />
          {" "}(it counts per UTC day).
        </div>)}
      <div style={{ marginTop: 8 }}>
        <button data-testid="llm-test-btn" style={styles.btnDim} disabled={testing} onClick={test}>
          {testing ? "Testing…" : "Test model"}
        </button>
        {res && (
          <div style={{ marginTop: 6 }} data-testid="llm-test-result">
            {res.ok ? (
              <>
                <span style={{ color: "var(--hs-safe)" }}>OK</span> · {res.provider} <code>{res.model}</code>
                {" "}· label <strong>{res.label}</strong> (confidence {res.confidence})
                {" "}· {res.latency_ms} ms · cost A${(res.cost_aud ?? 0).toFixed(4)}
                {" "}({res.input_tokens ?? 0} in / {res.output_tokens ?? 0} out tokens)
                {res.provider === "mock" && <span style={{ color: "var(--hs-warning)" }}> — mock model: no Anthropic key reached the app</span>}
              </>
            ) : (
              <>
                <span style={{ color: "var(--hs-danger)" }}>FAILED</span> · {res.provider} <code>{res.model}</code>
                {" "}· <code>{res.error_type}</code>{res.status ? ` (HTTP ${res.status})` : ""} · {res.latency_ms} ms
                <pre style={{ margin: "4px 0 0", whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12 }}>{res.error}</pre>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
